module.exports = __webpack_public_path__ + "img/horizontal_6_5_8003.af4f25da.png";